export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const LOGIN_ERROR = 'LOGIN_ERROR'